import type { StaticLayerPayload } from "@config";
import { DocumentInfoLibrary } from "@library-elements/document-info";
import type { ComponentType } from "react";
import { Container } from "../Container";

const Views: Record<string, ComponentType<StaticLayerPayload>> = {
  default: DocumentInfoLibrary,
};

export const DocumentInfo = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={Views} />
);
